export default __webpack_public_path__ + "static/media/sp-icon.250f1a2a.webp";